import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tln-kiwihr-logo',
  templateUrl: './kiwihr-logo.component.html',
  styleUrls: ['./kiwihr-logo.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class KiwihrLogoComponent {}
